interface ArticleViewProps {
    thumnailImageUrl?: string
    title: string
    subtitle: string
    subsubtitle: string
    description: string
    footer: string
    foregroundColor: number[]
    backgroundColor: number[]
    onTouch?: () => void
}



const ArticleView: React.FunctionComponent<ArticleViewProps> = (props: ArticleViewProps) => {
    return (
        <div onClick={() => {
            if (props.onTouch !== undefined) { props.onTouch() }
        }} style={{ cursor: props.onTouch === undefined ? 'cursor' : 'pointer', padding: 26, marginBottom: 16, marginTop: 16, borderRadius: "10px", color: `rgb(${props.foregroundColor[0]}, ${props.foregroundColor[1]}, ${props.foregroundColor[2]})`, backgroundColor: `rgb(${props.backgroundColor[0]}, ${props.backgroundColor[1]}, ${props.backgroundColor[2]})`, boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px" }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexFlow: 'wrap', columnGap: '2em', justifyItems: 'center', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {
                    props.thumnailImageUrl !== undefined &&
                    <img style={{ width: '150px', height: '100%' }} src={props.thumnailImageUrl}></img>
                }
                <div style={{ textAlign: "left", flex: '15em' }}>
                    <h1>{props.title}</h1>
                    <h2>{props.subtitle}</h2>
                    <h3>{props.subsubtitle}</h3>
                    <p>{props.description}</p>
                </div>

            </div>
            <footer style={{ fontSize: "0.7em", textAlign: 'right' }}>{props.footer}</footer>
        </div>
    )
}

export default ArticleView;